import { render, staticRenderFns } from "./driver-news.pug?vue&type=template&id=e4d26546&scoped=true&lang=pug&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./driver-news.scss?vue&type=style&index=0&id=e4d26546&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4d26546",
  null
  
)

export default component.exports